module.exports = __webpack_public_path__ + "static/media/mapfre.3ccc208f.png";